import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Checkbox, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { TermsOfServiceContent } from '~/client-flow/clientOb/ClientOnboardingInnerV2/OnboardingPage/Steps/TermsOfService/TermsOfServiceContent';
import { StepPage } from '~/client-flow/components/StepPage';
import { useLocaleKeys } from '~/i18n';
import styles from './TermsOfServiceStep.module.scss';
export const { TermsOfServiceStepTestIds } = getTestIds();
export function TermsOfServiceStep(param) {
    let { relationship, termsOfService, onBack, onNext, isStatementAccepted, onStatementChange, shouldSignStatement, isPeview } = param;
    var _relationship_legalTermsDocuments;
    const { t: clientFlowTexts } = useLocaleKeys('clientFlow.termsOfServiceStep');
    const termsOfServiceName = useMemo(()=>{
        var _relationship_legalTermsDocuments;
        if (((_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments.length) > 1) {
            return termsOfService.displayName.replace(/\.pdf$/i, '');
        }
        return "Terms of Service";
    }, [
        termsOfService.displayName,
        (_relationship_legalTermsDocuments = relationship.legalTermsDocuments) === null || _relationship_legalTermsDocuments === void 0 ? void 0 : _relationship_legalTermsDocuments.length
    ]);
    const statement = useMemo(()=>{
        return termsOfService.termsOfService.type === 'explicitApproval' ? termsOfService.termsOfService.explicitApproval.statement : null;
    }, [
        termsOfService.termsOfService
    ]);
    return /*#__PURE__*/ _jsx(StepPage, {
        header: clientFlowTexts.reviewHeader({
            termsName: termsOfServiceName
        }),
        primaryBtn: /*#__PURE__*/ _jsx(Button, {
            disabled: !isStatementAccepted,
            onClick: onNext,
            children: "Next"
        }),
        onBackBtnClick: onBack,
        contentClassName: styles.content,
        testId: TermsOfServiceStepTestIds.Root(),
        withinFooter: (isPeview || shouldSignStatement) && statement ? /*#__PURE__*/ _jsx(Checkbox, {
            className: styles.statementCheckbox,
            onChange: (e)=>onStatementChange(e.target.checked),
            testId: TermsOfServiceStepTestIds.StatementCheckbox(),
            checked: isStatementAccepted,
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "light",
                children: statement
            })
        }) : null,
        children: /*#__PURE__*/ _jsx("div", {
            "data-testid": TermsOfServiceStepTestIds.Content(),
            className: styles.termsOfServiceContent,
            children: /*#__PURE__*/ _jsx(TermsOfServiceContent, {
                relationship: relationship,
                termsOfService: termsOfService
            })
        })
    });
}
